export const RoomStatus = [
    { value: 'available', label: 'Available' },
    { value: 'closed', label: 'Closed' },
]

export type RoomStatusType = typeof RoomStatus[number]['value']